import script from "./GradientButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./GradientButton.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__